import { useQuery } from '@tanstack/react-query';
import { useLocation } from 'react-router-dom';

import { isAnnouncementsEnabled } from './announcementsEnabled';
import { AnnouncementsResponse } from './types';

export function useAnnouncementsQuery() {
  const { pathname } = useLocation();
  const enabled = isAnnouncementsEnabled();

  return useQuery<AnnouncementsResponse>({
    queryKey: ['announcements', pathname],
    queryFn: async () => {
      const params = new URLSearchParams({
        frontend: 'signup',
        path: pathname,
      });
      const response = await fetch(`/api/announcements/?${params}`);

      if (!response.ok) {
        throw new Error(`Announcements fetch failed: ${response.status}`);
      }

      return response.json();
    },
    enabled,
    staleTime: 60_000,
  });
}
